/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ api: NonNullable<unknown> }} Audit_Details_Api_Template_Deleted_DescInputs */



/**
* | output |
* | --- |
* | "The external API \"{api}\" was withdrawn, together with its spaces." |
*
* @param {Audit_Details_Api_Template_Deleted_DescInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const audit_details_api_template_deleted_desc = /** @type {((inputs: Audit_Details_Api_Template_Deleted_DescInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audit_Details_Api_Template_Deleted_DescInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`Die Freigabe der externen API "${i?.api}" wurde zurückgezogen, mitsamt ihren Spaces.`)
	return /** @type {LocalizedString} */ (`The external API "${i?.api}" was withdrawn, together with its spaces.`)
});